import React from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, LabelList, ResponsiveContainer } from 'recharts';
import { CHART_ACCENT, CHART_GRID, CHART_AXIS_TEXT, tooltipContentStyle, tooltipLabelStyle } from '../Other/Admin/charts/chartTheme';
import { getIconForSymbol } from './blockchainIcons';
import { formatUSD } from './dashboardFormat';

// Recharts ticks render inside the chart's own <svg> tree, so the icon must be an
// SVG <image> element here — a plain <img> tag is invalid inside <svg> and silently no-ops.
const CoinTick = ({ x, y, payload }) => {
  const icon = getIconForSymbol(payload.value);

  if (!icon) {
    return (
      <text x={x} y={y} dy={4} textAnchor="end" fill={CHART_AXIS_TEXT} fontSize={12}>
        {payload.value}
      </text>
    );
  }

  return (
    <image href={icon} x={x - 24} y={y - 10} width={20} height={20} />
  );
};

const BlockchainBreakdownChart = ({ perBlockchain }) => {
  const chartData = Object.entries(perBlockchain || {})
    .map(([symbol, value]) => ({ symbol, value: typeof value === 'number' ? value : 0 }))
    .filter((d) => d.value > 0)
    .sort((a, b) => b.value - a.value);

  if (chartData.length === 0) {
    return <div className="dash-chart-empty">No blockchain activity yet.</div>;
  }

  const chartHeight = Math.max(120, chartData.length * 40);

  return (
    <ResponsiveContainer width="100%" height={chartHeight}>
      <BarChart data={chartData} layout="vertical" margin={{ top: 4, right: 48, left: 4, bottom: 0 }} barCategoryGap="24%">
        <CartesianGrid stroke={CHART_GRID} strokeDasharray="0" horizontal={false} />
        <XAxis type="number" hide />
        <YAxis type="category" dataKey="symbol" tick={<CoinTick />} axisLine={false} tickLine={false} width={36} />
        <Tooltip
          contentStyle={tooltipContentStyle}
          labelStyle={tooltipLabelStyle}
          formatter={(value, _name, entry) => [formatUSD(value), entry.payload.symbol]}
          cursor={{ fill: 'rgba(255,255,255,0.04)' }}
        />
        <Bar dataKey="value" fill={CHART_ACCENT} maxBarSize={20} radius={[0, 4, 4, 0]}>
          <LabelList dataKey="value" position="right" formatter={formatUSD} fill="#fff" fontSize={12} />
        </Bar>
      </BarChart>
    </ResponsiveContainer>
  );
};

export default BlockchainBreakdownChart;
